import { render, staticRenderFns } from "./AdminInstructions.vue?vue&type=template&id=febc5e8a&scoped=true&"
import script from "./AdminInstructions.vue?vue&type=script&lang=js&"
export * from "./AdminInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febc5e8a",
  null
  
)

export default component.exports